if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };

        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main"); // contenedor del CTA principal
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm ? this.mainProductForm.querySelector(".m-add-to-cart") : null;
        this.mainDynamicCheckout = this.mainProductForm ? this.mainProductForm.querySelector(this.selectors.buyNowBtn) : null;

        this.disableSelectedVariantDefault =
          this.mainProduct?.dataset?.disableSelectedVariantDefault === "true" || false;

        this.domNodes = queryDomNodes(this.selectors, this.container);

        // Arranca oculto de forma explícita
        this.forceHide();

        this.init();
      }

      /* ---------- utilidades mostrar/ocultar ---------- */
      forceHide() {
        if (!this.container) return;
        this.container.classList.remove("is-ready");
        this.container.style.setProperty("display", "none", "important");
        this.container.style.setProperty("--m-translate-y", "100%", "important");
        document.documentElement.classList.remove("stick-atc-show");
      }

      forceShow() {
        if (!this.container) return;
        this.container.classList.add("is-ready");
        this.container.style.setProperty("display", "block", "important");
        this.container.style.setProperty("--m-translate-y", "0", "important");
        document.documentElement.classList.add("stick-atc-show");
        this.setStickyAddToCartHeight();
      }
      /* ------------------------------------------------ */

      init() {
        // Si no hay form principal, mostramos sticky siempre (caso raro)
        if (!this.mainProductForm) {
          this.forceShow();
          return;
        }

        this.variantData = this.getVariantData();

        // Observamos el bloque del CTA principal.
        // Si CUALQUIER parte del bloque es visible -> ocultamos sticky.
        // Si NO es visible -> mostramos sticky.
        const headerHeight = (window.MinimogSettings && window.MinimogSettings.headerHeight) || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  // CTA principal a la vista -> ocultar sticky
                  this.forceHide();
                } else {
                  // CTA principal fuera de vista -> mostrar sticky
                  this.forceShow();
                }
              });
            },
            {
              // Con threshold bajo alcanza con que "asome" para ocultar
              threshold: 0.01,
              rootMargin,
            }
          );
          this.setObserveTarget();
        } else {
          // Fallback sin IO
          const onScrollFallback = () => {
            const rect = this.mainProductForm.getBoundingClientRect();
            const header = (window.MinimogSettings && window.MinimogSettings.headerHeight) || 66;
            const visible =
              rect.bottom > header && rect.top < window.innerHeight; // alguna parte a la vista

            if (visible) this.forceHide();
            else this.forceShow();
          };
          window.addEventListener("scroll", onScrollFallback, { passive: true });
          window.addEventListener("resize", onScrollFallback, { passive: true });
          onScrollFallback();
        }

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        prodTitle?.addEventListener("click", () => __scrollToTop());
        mainImage?.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();
        this.syncWithMainProductForm();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.setStickyAddToCartHeight.bind(this);
        this.setStickyAddToCartHeight();
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(this.container.querySelector('[type="application/json"]').textContent || "[]");
        return this.variantData;
      }

      setObserveTarget() {
        if (this.observer && this.mainProductForm) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      setUnavailable() {
        const productForm = this.querySelector(".m-product-form");
        const addButton = productForm?.querySelector('[name="add"]');
        if (addButton) this.toggleAddButton(true, window.MinimogStrings.unavailable);
      }

      toggleAddButton(disable = true, text) {
        const productForm = this.querySelector(".m-product-form");
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.innerHTML = window.MinimogStrings.addToCart;
        }
      }

      handleDisableSelectedVariantDefault() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;
        const pickerField = this.querySelector(".m-product-option--dropdown-select");
        if (pickerField) pickerField.value = "";
        this.setUnavailable();
      }

      setStickyAddToCartHeight() {
        if (!this.offsetHeight) return;
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        if (window.MinimogSettings) window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
          const isMainProduct = e.data.sectionId === this.mainProduct?.dataset?.sectionId;
          if (!isMainProduct) return;
          this.currentVariant = e.data.variant;
          if (this.currentVariant) {
            if (variantInput) variantInput.value = e.data.variant.id;
            this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut);
          } else {
            if (variantInput) variantInput.value = "";
            this.toggleAddButton(true, window.MinimogStrings.unavailable);
          }
        });
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        let hasCustomFieldRequired = false;
        const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
        customFields?.forEach((item) => {
          const field = item.querySelector(".form-field");
          if (field?.value === "" && field.hasAttribute("required")) {
            hasCustomFieldRequired = true;
          }
        });

        if (hasCustomFieldRequired && addToCart) {
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart?.click());
          });
        }

        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.mainProductInfo);
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout?.click());
              }
            },
            true
          );
        }

        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart?.click());
          });
        }
      }
    }
  );
}
